type TInquiryTypeMaster = {
  REQUEST_ESTIMATE: string;
  REQUEST_SAMPLE: string;
  OTHER: string;
};

const INQUIRY_TYPE_MASTER = {
  REQUEST_ESTIMATE: "見積もり依頼",
  REQUEST_SAMPLE: "用紙サンプル（全種類）請求",
  OTHER: "その他のお問い合わせ"
} as TInquiryTypeMaster;

type TInquiryType = {
  inquiryType: string;
};

export { INQUIRY_TYPE_MASTER, TInquiryType };
